exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".windowBoxLock__window-container{position:fixed;background-color:rgba(0,0,0,.5);top:0;left:0;bottom:0;right:0;z-index:9999}.windowBoxLock__window{width:600px;border-radius:5px;background-color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);margin:0;padding:0;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.windowBoxLock__window-title{position:relative;background-color:#157fcc;color:#fff;border-radius:5px 5px 0 0;padding:0 20px;height:auto}.windowBoxLock__window-title h1{line-height:20px;margin:0;font-size:1rem;padding-top:8px;padding-bottom:8px}.windowBoxLock__new-window-body{padding:30px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/WindowBoxLock/style.css
 ** module id = 1941
 ** module chunks = 73
 **/